import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_MEDREFILL_MEDICATIONS_LIST_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { GetMedicationListPayload, GetMedicationListResult } from '../types/getMedicationList.type';

export const TAG_MEDREFILL_MEDICATION_LIST = 'getMedicationList';
export const getMedicationList = <T extends BuilderType>(builder: T) =>
  builder.query<GetMedicationListResult, GetMedicationListPayload>({
    providesTags: [TAG_MEDREFILL_MEDICATION_LIST],
    query: (params) => ({
      data: params,
      method: 'POST',
      url: GET_MEDREFILL_MEDICATIONS_LIST_URL,
    }),
    transformResponse: (response: GenericApiResponse<GetMedicationListResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
